module.exports = "/assets/658b36797da023e3ee397df75e4d7a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/expedia.png
// module id = 605
// module chunks = 0